import { render } from "./RedirectingApp.vue?vue&type=template&id=1b9c914a&scoped=true"
import script from "./RedirectingApp.vue?vue&type=script&lang=js"
export * from "./RedirectingApp.vue?vue&type=script&lang=js"

import "./RedirectingApp.vue?vue&type=style&index=0&id=1b9c914a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b9c914a"

export default script